import React from "react"
import styled from "@emotion/styled"
import { Box } from "@rebass/grid/emotion"
import { TextElement } from "@nutrafol/nutrafol-ui-kit/dist/TextElement"
import { TextElementMen } from "@nutrafol/nutrafol-ui-kit/dist/TextElementMen"
import theme from "@nutrafol/nutrafol-ui-kit/styles/theme"

const Wrap = styled.div`
  &.text-master-base-black {
    * {
      color: ${theme.wild.color.master.base.black} !important;
    }
  }
`
const Container = styled(Box)`
  text-align: center;
  @media (max-width: 767px) {
    padding-left: 10%;
    padding-right: 10%;
  }
  .men-text {
    @media (min-width: ${theme.mediaqueries.medium}) {
      //font-size: 14px !important;
      //line-height: 19.6px !important;
    }
  }
`

const Items = styled.div`
  line-height: 120%;
  span.textelement.men[class*="body--"],
  span.textelement.men[class*="body--"] span {
    line-height: 1;
  }
`

const References = ({ data }) => {
  const { line1, line2, items, pt, pb, type, maxWidth, className = "" } = data

  const Cmp = type === "men" ? TextElementMen : TextElement
  return (
    <Wrap className={className}>
      <Container
        className={`wild-container`}
        pt={pt}
        pb={pb}
        maxWidth={maxWidth || null}
      >
        {line1 && (
          <Cmp
            text={line1}
            element="p"
            className={`${
              type === "men"
                ? "body--small text-master-base-alt-alt men-text"
                : "body--small women text-nova-transparency-black-60"
            }`}
          />
        )}
        {line2 && (
          <Cmp
            text={line2}
            element="p"
            className={`${
              type === "men"
                ? "body--small text-master-base-alt-alt men-text"
                : "body--small women text-nova-transparency-black-60"
            }`}
          />
        )}
        <Items>
          {items && (
            <>
              {items.map((item, i) => {
                const text = `<span>${i + 1}.</span> ${item} `
                return (
                  <Cmp
                    text={text}
                    element="span"
                    className={`${
                      type === "men"
                        ? "body--small text-master-base-alt-alt men-text"
                        : "body--small women text-nova-transparency-black-60"
                    }`}
                    key={i}
                  />
                )
              })}
            </>
          )}
        </Items>
      </Container>
    </Wrap>
  )
}

export default References
